import React from 'react';

export default function Policy() {
  const lastUpdated = "2026年3月2日"; // 適宜修正してください

  const sectionStyle = {
    marginBottom: '30px',
  };

  const h3Style = {
    fontSize: '18px',
    color: '#2c3e50',
    borderBottom: '2px solid #e74c3c',
    paddingBottom: '5px',
    marginBottom: '15px'
  };

  const pStyle = {
    fontSize: '14px',
    lineHeight: '1.8',
    color: '#34495e',
    textAlign: 'justify'
  };

  return (
    <div style={{ padding: '100px 20px 60px', maxWidth: '800px', margin: '0 auto', fontFamily: 'sans-serif', backgroundColor: '#fff' }}>
      <h1 style={{ textAlign: 'center', color: '#2c3e50', marginBottom: '10px' }}>サイトポリシー</h1>
      <p style={{ textAlign: 'right', fontSize: '12px', color: '#95a5a6', marginBottom: '40px' }}>最終更新日：{lastUpdated}</p>

      <section style={sectionStyle}>
        <h3 style={h3Style}>1. はじめに</h3>
        <p style={pStyle}>
          このサイトポリシー（以下「本ポリシー」）は、ゆきけん運営事務局および白峰 雪人（以下「当方」）が提供するサービス（以下「本サービス」）の利用条件を定めるものです。ユーザーの皆様には、本ポリシーに従って本サービスをご利用いただきます。
        </p>
      </section>

      <section style={sectionStyle}>
        <h3 style={h3Style}>2. 個人情報の取り扱い</h3>
        <p style={pStyle}>
          当方は、ユーザーのメールアドレス、性別、およびアップロードされた画像データを、本サービスの提供および利便性向上の目的でのみ利用します。これらのデータは、法令に基づく場合を除き、正当な理由なく第三者に開示することはありません。
        </p>
      </section>

      <section style={sectionStyle}>
        <h3 style={h3Style}>3. AIによる分析結果について</h3>
        <p style={pStyle}>
          本サービスで提供される栄養分析結果およびアドバイスは、生成AI（Gemini）による推論に基づいています。当方はその情報の正確性、完全性、有用性を保証するものではありません。あくまで一般的な情報の提供を目的としており、医師の診断や専門的な栄養指導に代わるものではないことをご理解ください。
        </p>
      </section>

      <section style={sectionStyle}>
        <h3 style={h3Style}>4. 禁止事項</h3>
        <p style={pStyle}>
          ユーザーは、本サービスの利用にあたり、以下の行為を行ってはなりません。
        </p>
        <ul style={pStyle}>
          <li>法令または公序良俗に違反する行為</li>
          <li>本サービスの運営を妨害するおそれのある行為</li>
          <li>他人の個人情報や画像を無断で収集または利用する行為</li>
          <li>その他、当方が不適切と判断する行為</li>
        </ul>
      </section>

      <section style={sectionStyle}>
        <h3 style={h3Style}>5. 免責事項</h3>
        <p style={pStyle}>
          本サービスの利用によりユーザーに生じた損害について、当方は一切の責任を負いません。また、本サービスは予告なく停止、中断、または内容の変更を行うことがあります。
        </p>
      </section>

      <section style={sectionStyle}>
        <h3 style={h3Style}>6. お問い合わせ</h3>
        <p style={pStyle}>
          本ポリシーに関するお問い合わせは、info@yukiken.netまでお願いいたします。
        </p>
      </section>

      <div style={{ textAlign: 'center', marginTop: '60px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
        <button 
          onClick={() => window.history.back()}
          style={{ padding: '10px 30px', background: '#2c3e50', color: '#fff', border: 'none', borderRadius: '25px', cursor: 'pointer' }}
        >
          戻る
        </button>
      </div>
    </div>
  );
}